// src/pages/micuenta/PaymentMethods.jsx
import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { FaArrowLeft } from "react-icons/fa";
import "./metodosdepago.css";

function PaymentMethods() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  if (!user) {
    return (
      <div className="account-container">
        <div className="account-card">
          <h2 className="account-title">Cargando usuario...</h2>
        </div>
      </div>
    );
  }

  // Función para regresar a "/mi-cuenta" sin query string
  const handleBack = () => {
    navigate("/mi-cuenta");
  };

  // Estado para métodos de pago (ejemplo inicial)
  const [paymentMethods, setPaymentMethods] = useState([
    {
      id: 1,
      cardNumber: "xxxx-xxxx-xxxx-1234",
      cardName: "John Doe",
      expDate: "09/26",
      cvv: "336",
      addressLine1: "Calle X #123",
      addressLine2: "Apt. 1",
      city: "Ciudad",
      state: "Estado",
      zip: "12345",
      country: "País",
    },
  ]);

  const [isAdding, setIsAdding] = useState(false);
  const [isEditing, setIsEditing] = useState(null); // Guardará el id del método en edición

  const [formData, setFormData] = useState({
    cardNumber: "",
    cardName: "",
    expDate: "",
    cvv: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zip: "",
    country: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  // Función para enmascarar el número de tarjeta
  const maskCardNumber = (number) => {
    if (!number) return "";
    const last4 = number.slice(-4);
    return `xxxx-xxxx-xxxx-${last4}`;
  };

  // Agregar un método nuevo
  const handleAddNew = () => {
    setIsAdding(true);
    setIsEditing(null);
    setFormData({
      cardNumber: "",
      cardName: "",
      expDate: "",
      cvv: "",
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      zip: "",
      country: "",
    });
  };

  // Guardar un método nuevo
  const handleSaveNew = () => {
    const newMethod = {
      id: Date.now(),
      ...formData,
      cardNumber: maskCardNumber(formData.cardNumber),
    };
    setPaymentMethods((prev) => [...prev, newMethod]);
    setIsAdding(false);
  };

  // Editar método existente
  const handleEdit = (method) => {
    setIsEditing(method.id);
    setIsAdding(false);
    setFormData({
      ...method,
      cardNumber: method.cardNumber,
    });
  };

  // Guardar edición
  const handleSaveEdit = () => {
    setPaymentMethods((prev) =>
      prev.map((m) =>
        m.id === isEditing
          ? { ...formData, id: m.id, cardNumber: maskCardNumber(formData.cardNumber) }
          : m
      )
    );
    setIsEditing(null);
  };

  // Eliminar método de pago
  const handleDelete = (id) => {
    if (window.confirm("¿Deseas eliminar este método de pago?")) {
      setPaymentMethods((prev) => prev.filter((m) => m.id !== id));
    }
  };

  return (
    <div className="account-container">
      <div className="account-card">
        {/* Botón para regresar a Mi Cuenta */}
        <button className="back-button" onClick={handleBack}>
          <FaArrowLeft className="back-icon" /> Regresar a Mi Cuenta
        </button>

        <h2 className="account-section-title">Métodos de Pago</h2>

        {/* Vista de lista (cuando no se está agregando ni editando) */}
        {(!isAdding && isEditing === null) && (
          <>
            {paymentMethods.length === 0 ? (
              <p>No hay métodos de pago registrados</p>
            ) : (
              <div className="payment-methods-list">
                {paymentMethods.map((method) => (
                  <div className="payment-method-card" key={method.id}>
                    <div className="pmc-row">
                      <span className="pmc-label">Número en la tarjeta:</span>
                      <span className="pmc-value">{method.cardNumber}</span>
                    </div>
                    <div className="pmc-row">
                      <span className="pmc-label">Nombre en la tarjeta:</span>
                      <span className="pmc-value">{method.cardName}</span>
                    </div>
                    <div className="pmc-row">
                      <span className="pmc-label">Fecha de expiración:</span>
                      <span className="pmc-value">{method.expDate}</span>
                    </div>
                    <div className="pmc-row">
                      <span className="pmc-label">Código CVV:</span>
                      <span className="pmc-value">{method.cvv}</span>
                    </div>
                    <div className="pmc-row">
                      <span className="pmc-label">Dirección de facturación:</span>
                      <span className="pmc-value">
                        {method.addressLine1} {method.addressLine2} <br />
                        {method.city}, {method.state}, {method.zip} <br />
                        {method.country}
                      </span>
                    </div>
                    <div className="pmc-actions">
                      <button className="pmc-edit-btn" onClick={() => handleEdit(method)}>
                        Editar
                      </button>
                      <button className="pmc-delete-btn" onClick={() => handleDelete(method.id)}>
                        Eliminar
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
            <button className="btn-add-payment" onClick={handleAddNew}>
              Agregar Método de Pago
            </button>
          </>
        )}

        {/* Formulario para agregar / editar */}
        {(isAdding || isEditing !== null) && (
          <form className="register-form">
            <div className="form-group">
              <label>Número en la tarjeta:</label>
              <div className="input-wrapper">
                <input
                  type="text"
                  className="form-control"
                  name="cardNumber"
                  value={formData.cardNumber}
                  onChange={handleChange}
                  placeholder="xxxx-xxxx-xxxx-1234"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Nombre en la tarjeta:</label>
              <div className="input-wrapper">
                <input
                  type="text"
                  className="form-control"
                  name="cardName"
                  value={formData.cardName}
                  onChange={handleChange}
                  placeholder="Tu nombre"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Fecha de expiración (MM/AA):</label>
              <div className="input-wrapper">
                <input
                  type="text"
                  className="form-control"
                  name="expDate"
                  value={formData.expDate}
                  onChange={handleChange}
                  placeholder="09/26"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Código CVV:</label>
              <div className="input-wrapper">
                <input
                  type="text"
                  className="form-control"
                  name="cvv"
                  value={formData.cvv}
                  onChange={handleChange}
                  placeholder="336"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Calle y Número:</label>
              <div className="input-wrapper">
                <input
                  type="text"
                  className="form-control"
                  name="addressLine1"
                  value={formData.addressLine1}
                  onChange={handleChange}
                  placeholder="Calle X #123"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Apt. / Suite (opcional):</label>
              <div className="input-wrapper">
                <input
                  type="text"
                  className="form-control"
                  name="addressLine2"
                  value={formData.addressLine2}
                  onChange={handleChange}
                  placeholder="Apt. 1"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Ciudad:</label>
              <div className="input-wrapper">
                <input
                  type="text"
                  className="form-control"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  placeholder="Ciudad"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Estado/Provincia:</label>
              <div className="input-wrapper">
                <input
                  type="text"
                  className="form-control"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  placeholder="Estado"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Código Postal:</label>
              <div className="input-wrapper">
                <input
                  type="text"
                  className="form-control"
                  name="zip"
                  value={formData.zip}
                  onChange={handleChange}
                  placeholder="12345"
                />
              </div>
            </div>

            <div className="form-group">
              <label>País:</label>
              <div className="input-wrapper">
                <input
                  type="text"
                  className="form-control"
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                  placeholder="País"
                />
              </div>
            </div>

            <div className="payment-form-actions">
              <button
                type="button"
                className="pmc-cancel-btn"
                onClick={() => {
                  setIsAdding(false);
                  setIsEditing(null);
                }}
              >
                Cancelar
              </button>
              {isAdding && (
                <button type="button" className="pmc-save-btn" onClick={handleSaveNew}>
                  Guardar Nuevo
                </button>
              )}
              {isEditing !== null && (
                <button type="button" className="pmc-save-btn" onClick={handleSaveEdit}>
                  Guardar Cambios
                </button>
              )}
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default PaymentMethods;